var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50035 17.7161C14.0224 17.7161 17.6882 14.0444 17.6882 9.51517C17.6882 4.98592 14.0224 1.31424 9.50035 1.31424C4.97832 1.31424 1.3125 4.98592 1.3125 9.51517C1.3125 14.0444 4.97832 17.7161 9.50035 17.7161Z",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.7161V28.6858",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83496 25.3037H13.1655",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroFemale);
export default __webpack_public_path__ + "static/media/buroFemale.8aeaac3b472081b1dd0570bf2c1ea498.svg";
export { ForwardRef as ReactComponent };